<div class="conclusion-loading h-70vh">
    <div class="displayText">{{displayText}}</div>
</div>
